import { createGlobalStyle } from 'styled-components';
import 'normalize.css';

import { CUSTOM_TQ_COLOURS } from './colours';

const TqGlobalStyle = createGlobalStyle`
  .footer-fa-icon {
    width: 45px;
    height: 45px;
    border-radius: 3px;
    line-height: 20px;
    padding: 16px;
    background: white;
    color: ${CUSTOM_TQ_COLOURS.blue072C4D};
  }`;

export default TqGlobalStyle;
